import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './NotFound.css';

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Page Not Found | Blisstainment</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <main className="not-found text-center" aria-labelledby="not-found-title">
        <section className="pd50">
          <div className="container">
            <div className="not-found-code" aria-label="Error 404">
              <span aria-hidden="true">4</span>
              <span className="not-found-record" aria-hidden="true" />
              <span aria-hidden="true">4</span>
            </div>
            <p className="not-found-label">PAGE NOT FOUND</p>
            <h1 id="not-found-title">Looks like this track is missing.</h1>
            <p className="not-found-copy">The page you’re looking for may have moved, or the link may be out of tune.
              Let’s get you back to the music, movies, and moments you love.</p>
            <div className="not-found-actions">
              <Link to="/" className="home_btn">Back to Home</Link>
              <Link to="/music" className="home_btn not-found-secondary">Explore Music</Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
